import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

import Loader from "@/components/loader";

import api from "@/services/api";
import useStore from "@/services/store";

export default function Connect() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { setUser, setOrganization, setImpersonation } = useStore();

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const user_id = params.get("user_id");
  const redirect_url = params.get("redirect_url");

  async function loginAsUser() {
    try {
      setImpersonation(true);
      api.setToken(token);

      const res = await api.get(`/user/token_user/${user_id}`);

      if (!res.ok) {
        setError(true);
        setLoading(false);
        return;
      }

      if (res.token) api.setToken(res.token);
      if (res.user) setUser(res.user);
      setOrganization(res.organisations?.[0] || null);
      setLoading(false);
    } catch (e) {
      console.error("Error logging in as user:", e);
      setError(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (token && user_id) {
      loginAsUser();
    } else {
      setError(true);
      setLoading(false);
    }
  }, []);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center max-w-md">
          <h1 className="text-2xl font-bold text-red-600 mb-2">Error</h1>
          <p className="text-gray-600 mb-4">Failed to login as user. Please check the browser console for details.</p>
          <button onClick={() => window.close()} className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">
            Close Window
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  }

  return <Navigate to={redirect_url || "/"} replace />;
}
